module.exports = __webpack_public_path__ + "img/dummy_staff_m.c985d809.png";